import createReducer from './reducerUtils'
import { LOAD_CREDITO, LOAD_CREDITOS, LOADING_CREDITOS, LOADING_CREDITO, LOAD_CUOTAS, LOADING_CUOTAS } from '../actions/actionTypes'

const initialState = {
  creditos: [],
  credito: null,
  cuotas: [],
  loadingCreditos: false,
  loadingCredito: false,
  loadingCuotas: false
}


const loadCreditos = (state, payload) => {
  return {
    ...state,
    creditos: payload.creditos,
  }
}

const loadCredito = (state, payload) => {
  return {
    ...state,
    credito: payload.credito
  }
}

const loadCuotas = (state, payload) => {
  return {
    ...state,
    cuotas: payload.cuotas,
  }
}

const loadingCreditos = (state, payload) => {
  return { ...state, loadingCreditos: payload.loading }
}

const loadingCredito = (state, payload) => {
  return { ...state, loadingCredito: payload.loading }
}


const loadingCuotas = (state, payload) => {
  return { ...state, loadingCuotas: payload.loading }
}


export default createReducer(initialState, {
  [LOAD_CREDITOS]: loadCreditos,
  [LOADING_CREDITOS]: loadingCreditos,
  [LOAD_CREDITO]: loadCredito,
  [LOADING_CREDITO]: loadingCredito,
  [LOAD_CUOTAS]: loadCuotas,
  [LOADING_CUOTAS]: loadingCuotas,
})
